import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=5e4f318c&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=ts"
export * from "./Searchbar.vue?vue&type=script&lang=ts"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=5e4f318c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f318c",
  null
  
)

export default component.exports